<template>
  <div class="footer">
    <div class="footerBox">
      <div class="none"></div>
      <div class="box"
           v-if="lang==='zh'">
        <span>@2019 云路教育咨询（北京）有限公司 版权所有</span>
        <ul>
          <li>手机版</li>
          <li>管理登录</li>
          <li>京ICP备12049406号-1</li>
        </ul>
      </div>
      <div class="box"
           v-else>
        <span style="text-align:right;margin-right:0;">British Education Consultancy - CEC 2019 @ / Cherry Education Consultancy</span>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '@/utils/bus.js'
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'Footer',
      lang: window.sessionStorage.getItem('lang') === null ? 'zh' : window.sessionStorage.getItem('lang')
    }
  },
  created () {
    Bus.$on('langChange', lang => {
      this.lang = lang
    })
  }
}
</script>

<style scoped lang='scss'>
@import "@/styles/function.scss";
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  height: px(100);
  width: 100%;
  & > div.footerBox {
    display: flex;
    align-items: center;
    div.none {
      width: px(655);
      height: px(100);
    }
    & > div.box {
      background-color: #fff;

      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-top: px(60);
      padding-bottom: px(25);
      color: #4d4d4d;
      font-size: px(15);
      flex: 1;
      min-width: 0;
      margin: 0 auto;
      margin-right: px(73);
      padding-right: px(133);
      text-align: right;
      box-sizing: border-box;
      height: px(100);
      & > span {
        margin-right: px(71);
      }
      ul {
        min-width: 0;
        display: flex;
        padding: 0;
        margin: 0;
        list-style: none;
        li {
          padding: 0;
          margin: 0;
          list-style: none;
          margin: px(4) 0;
          padding: 0 px(4);
          border-right: 1px solid #4d4d4d;
          &:last-child {
            border: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue